import { Container, Row, Col, Card } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { FeatherIcons, Icons } from "../../../Constant";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { FeatherIconCardBody } from "./FeatherIconCardBody";

const FeatherIconContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={FeatherIcons} parent={Icons} title={FeatherIcons} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={FeatherIcons} />
              <FeatherIconCardBody />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FeatherIconContainer;
